<template>
    <v-row justify="center">
    <v-dialog v-model="abrir" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{configuracion.titulo}}</span>
          
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                  <v-alert
                    :border="configuracion.border"
                    colored-border
                    :type="configuracion.tipo"
                    elevation="2"
                    >
                    <h3>{{configuracion.mensaje}}</h3>
                    </v-alert>
                
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="abrir = false">Cancelar</v-btn>
          <v-btn color="red darken-1" dark @click="confirmar">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
    data:()=>({
        configuracion:{},
        abrir:false,
        item:{}
    }),
    beforeDestroy() {
      Event.$off('abrir_modal_confirmacion');
      Event.$off('cerrar_modal_confirmacion');
    },
    mounted(){
        Event.$on('abrir_modal_confirmacion',(configuracion,item)=>{
            this.configuracion = configuracion;
            this.abrir = true;
            this.item = item;
        });

        Event.$on('cerrar_modal_confirmacion',()=>{
            this.abrir = false;
        });
    },

    methods: {
        confirmar(){
            this.$emit('confirmar',this.item);
        }
    },
}
</script>